export default 'reportsApp';
